import L from 'leaflet';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import autosize from 'autosize';
import Mousetrap from 'mousetrap';
import intl from 'react-intl-universal';

import ThumbRating from "../ThumbRating";
import StarRating from "../StarRating";

import './EditModal.css';


@observer
class EditModal extends Component {
    componentDidMount = (e) => {
        autosize(this.textarea);
        Mousetrap.bind(['enter'], this.handleSave);
        L.DomEvent.disableClickPropagation(this.wrapperDOMref);
    };
    componentWillUnmount = () => {
        Mousetrap.unbind(['enter'], this.handleSave);
    };
    handleTextChange = (e) => {
        this.props.appStore.setPendingElementText(e.target.value);
    };

    handleDelete = () => {
        this.props.appStore.elementStore.removeElement(this.props.appStore.pendingState.element.uuid);
        this.props.appStore.clearPending();
    };
    handleCancel = () => {
        if (!this.props.appStore.pendingState.editing) {
            this.props.appStore.elementStore.removeElement(this.props.appStore.pendingState.element.uuid);
        }
        this.props.appStore.clearPending();
    };
    handleSave = () => {
        if (this.props.appStore.elementStore.inStore(this.props.appStore.pendingState.element)) {
            this.props.appStore.elementStore.updateElement(this.props.appStore.pendingState.element.uuid, this.props.appStore.pendingState.element);
        } else {
            this.props.appStore.elementStore.addElement(this.props.appStore.pendingState.element);
        }
        this.props.appStore.clearPending();
    };

    getEditTitle = (editing, elementTypeText) => {
        if (editing) {
            return intl.get("EditModal.editTitle", {icon_type: elementTypeText});
        }
        return intl.get("EditModal.addTitle", {icon_type: elementTypeText});
    };


    render() {
        if (!this.props.appStore.pendingState.element) {
            return (null);
        }
        let elementTypeText = this.props.appStore.pendingState.element.type;

        return (
            <div className="EditModal" ref={ref => this.wrapperDOMref = ref}>
                <div>
                    <h4>{this.getEditTitle(this.props.appStore.pendingState.editing, elementTypeText)}</h4>

                    {this.props.appStore.pendingState.element.icon.extra === "thumbs" &&
                        <ThumbRating appStore={this.props.appStore}/>
                    }
                    {this.props.appStore.pendingState.element.icon.extra === "stars" &&
                        <StarRating appStore={this.props.appStore}/>
                    }

                    {this.props.appStore.pendingState.element.icon.commentBox &&
                        <div>
                            <p>{this.props.appStore.pendingState.element.icon.commentPrompt ? this.props.appStore.pendingState.element.icon.commentPrompt : intl.get("EditModal.commentTitle", {icon_type: elementTypeText})}</p>
                            <textarea ref={c => this.textarea = c} onChange={this.handleTextChange}
                                      value={this.props.appStore.pendingState.element.text} rows={2}
                                      placeholder={intl.get("EditModal.textarea_placeholder")}/>
                        </div>}

                    <div className="buttons">
                        {this.props.appStore.pendingState.editing &&
                        <button className="delete" onClick={this.handleDelete}>
                            {intl.get("EditModal.delete")}
                        </button>
                        }

                        <button className="cancel" onClick={this.handleCancel}>
                            {intl.get("EditModal.cancel")}
                        </button>

                        <button className="save" onClick={this.handleSave}>
                            {intl.get("EditModal.save")}
                        </button>


                    </div>
                </div>
            </div>
        );
    }
}

export default EditModal;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PopupContainer/components/EditModal/index.js